export default "__VITE_ASSET__C0xm2D$o__"